<template>
  <q-btn class="badge-danger btn tw-controller-trigger-btn" @click="toggleShowControls()" floating>

    <img src="@/assets/icons/controlles.svg" alt="" />
    <q-badge color="red" floating v-if="controls > 0"> {{ controls }}</q-badge>



  </q-btn>
  <ControlsDialog />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import store from "@/store";
import ControlsDialog from "@/components/controls/ControlsDialog.vue";

@Options({
  components: { ControlsDialog }
})
export default class ControlsButton extends Vue {

  toggleShowControls() {
    return store.dispatch('controlsModule/toggleShow')
  }

  get controls() {
    return store.state.controlsModule.errors.length + store.state.controlsModule.warnings.length
  }

}
</script>

<style scoped></style>
